export default __webpack_public_path__ + "static/blockchain_crypto-b1f772b4654cd376bd37ff635017c990.png";